import uuidv4 from 'uuid/v4'

/**
 * アップロード画像クラス（一問一答）
 * @class
 * @property {number} id 既存画像の ID
 * @property {string} name 画像ファイル名
 * @property {string} base64 画像を Base64 変換した文字列
 * @property {number} width 幅
 * @property {number} height 高さ
 * @property {string} signedUrl 署名付き URL
 * @property {string} key 内部キー
 */
class UploadImage {
  /**
   * @typedef {Object} UploadImageParam
   * @property {number} id
   * @property {string} name
   * @property {string} base64
   * @property {number} width
   * @property {number} height
   * @property {string} signedUrl
   */

  /**
   * UploadImage コンストラクタ
   * @param {UploadImageParam} param
   */
  constructor({ id, name, base64, width, height, signedUrl }) {
    this.id = id || null
    this.name = name || null
    this.base64 = base64 || null
    this.width = width
    this.height = height
    this.signedUrl = signedUrl || ''
    this.key = this.createUniqueKey()
  }

  /**
   * 画像パス
   * @returns {string}
   */
  get imagePath() {
    return this.base64 || this.signedUrl
  }

  /**
   * リストレンダリング用のユニークキーを生成する
   * @returns {string} Key
   */
  createUniqueKey() {
    // 画面から追加した画像にはidがなく、ファイル名も重複OKなので、
    // UUIDをユニークキーとして追加する
    return uuidv4()
  }

  /**
   * @typedef {Object} Answer
   * @property {string} image_name
   * @property {number|undefined} answer_image_id
   * @property {string|undefined} signed_url
   * @property {string|undefined} image_base64
   */

  /**
   * API側のJSON定義に合うように変換する
   * @returns {Answer}
   */
  getAnswer() {
    // 既存画像
    if (this.id) {
      return {
        image_name: this.name,
        answer_image_id: this.id,
        signed_url: this.signedUrl
      }
    }

    // 新規画像
    return { image_name: this.name, image_base64: this.base64 }
  }
}

export default UploadImage
